import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import MessagesInTransit from './MessagesInTransit'
import ExpandedMediaModal from './ExpandedMediaModal'
import PendingMediaMessage from './PendingMediaMessage'
import Text from './Text'
import Email from './Email'
import { sameMessagesArray } from './utils'
import css from './styles/messages-container.css'

class MessagesContainer extends Component {
  static propTypes = {
    attachedMedia: PropTypes.string,
    conversationById: PropTypes.objectOf(
      PropTypes.shape({
        active: PropTypes.bool,
        created_at: PropTypes.string,
        id: PropTypes.number,
        patients: PropTypes.arrayOf(
          PropTypes.shape({
            first_name: PropTypes.string,
            last_name: PropTypes.string,
          }),
        ),
        seen: PropTypes.bool,
        subject: PropTypes.string,
        updated_at: PropTypes.string,
      }),
    ),
    conversationId: PropTypes.number,
    handleMessageFocus: PropTypes.func,
    hasRemindersTier2: PropTypes.bool.isRequired,
    isBlastMsg: PropTypes.bool.isRequired,
    isEditorFocused: PropTypes.bool.isRequired,
    isEmail: PropTypes.bool,
    isPatientsPage: PropTypes.bool,
    isSending: PropTypes.bool.isRequired,
    messages: PropTypes.arrayOf(PropTypes.object).isRequired,
    previewPendingMedia: PropTypes.func,
    selectedMessageId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    showMmsFromUnknownNumbers: PropTypes.bool,
  }

  state = {
    expandedMessageUrl: null,
  }

  componentDidMount = () => {
    this.scrollToBottom()
  }

  shouldComponentUpdate = (prevProps, prevState) => {
    const {
      conversationId,
      attachedMedia,
      isEmail,
      messages,
      isEditorFocused,
      isSending,
      selectedMessageId,
    } = this.props
    const { expandedMessageUrl } = this.state

    if (
      prevProps.conversationId === conversationId &&
      prevProps.attachedMedia === attachedMedia &&
      prevState.expandedMessageUrl === expandedMessageUrl &&
      prevProps.isEmail === isEmail &&
      prevProps.messages.length === messages.length &&
      prevProps.isEditorFocused === isEditorFocused &&
      prevProps.isSending === isSending &&
      prevProps.selectedMessageId === selectedMessageId &&
      sameMessagesArray(prevProps.messages, messages)
    ) {
      return false
    }
    return true
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { messages, selectedMessageId } = this.props

    if (
      (prevProps.selectedMessageId === selectedMessageId ||
        (messages.length &&
          selectedMessageId === messages[messages.length - 1].id)) &&
      this.state.expandedMessageUrl === null &&
      prevState.expandedMessageUrl === null
    ) {
      this.scrollToBottom()
    }
  }

  scrollToBottom = () => {
    this.scrollTarget.scrollIntoView(false)
  }

  handleExpandedMessage = (expandedMessageUrl) => {
    this.setState({ expandedMessageUrl })
  }

  unknownNumber = (msg) => {
    const { isEmail, conversationById } = this.props
    if (isEmail) return false
    const convo = conversationById[msg.conversation_id]
    return !convo.hasOwnProperty('patients') || convo.patients.length < 1
  }

  render() {
    const {
      isEmail,
      isBlastMsg,
      messages,
      attachedMedia,
      previewPendingMedia,
      handleMessageFocus,
      selectedMessageId,
      isPatientsPage,
      hasRemindersTier2,
      practiceName,
      showMmsFromUnknownNumbers,
    } = this.props
    const { expandedMessageUrl } = this.state

    let outerWrapper
    let innerWrapper
    let ConvoMessage

    if (isEmail) {
      outerWrapper = cx(css.outerWrapper, css.emailOuterWrapper, {
        [css.blastEmail]: isBlastMsg,
      })
      innerWrapper = cx(css.innerWrapper, css.emailInnerWrapper)
      ConvoMessage = Email
    } else {
      outerWrapper = cx(css.outerWrapper, css.textOuterWrapper)
      innerWrapper = cx(css.innerWrapper, css.textInnerWrapper)
      ConvoMessage = Text
    }

    const shouldRenderMessages = (!isEmail || !isBlastMsg) && messages

    return (
      <div className={outerWrapper}>
        {!!expandedMessageUrl && (
          <ExpandedMediaModal
            url={expandedMessageUrl}
            handleExpandedMessage={this.handleExpandedMessage}
            isPatientsPage={isPatientsPage}
          />
        )}
        <div
          className={innerWrapper}
          ref={(el) => {
            this.scrollTarget = el
          }}
        >
          {shouldRenderMessages &&
            messages.map(msg => (
              <ConvoMessage
                message={msg}
                key={msg.id}
                handleClick={handleMessageFocus}
                isSelected={msg.id === selectedMessageId}
                handleExpandedMessage={this.handleExpandedMessage}
                hasRemindersTier2={hasRemindersTier2}
                unknownNumber={this.unknownNumber(msg)}
                practiceName={practiceName}
                showMmsFromUnknownNumbers={showMmsFromUnknownNumbers}
              />
            ))}

          {!!attachedMedia && (
            <PendingMediaMessage
              mediaBase64Data={attachedMedia}
              previewPendingMedia={previewPendingMedia}
            />
          )}
          {this.props.isSending && <MessagesInTransit />}
        </div>
      </div>
    )
  }
}

export default MessagesContainer



// WEBPACK FOOTER //
// ./src/components/Messages/MessagesContainer.js